var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSectionBg8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 133,
    height: 169,
    viewBox: "0 0 133 169",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M98.8187 158.599L71.7581 144.707C67.5107 142.507 64.2664 140.151 61.9715 138.267C59.6958 136.401 57.7842 134.531 56.2201 132.815C56.1385 132.734 56.0629 132.646 55.9803 132.563C55.4205 131.934 54.9022 131.334 54.4306 130.767C52.6002 128.555 51.4602 126.812 50.927 125.994C50.6187 125.522 50.3316 125.057 50.0667 124.585C43.5641 113.563 42.8057 102.545 42.4167 96.8827C42.3821 96.4806 42.3616 96.0641 42.335 95.6681C42.335 95.6681 42.3422 95.6609 42.335 95.6537C42.2927 93.9601 42.2737 92.2726 42.2595 90.5926C42.2534 90.5048 42.2595 90.4435 42.2595 90.3884C42.2465 89.8685 42.2258 89.3444 42.2257 88.8374C42.0613 77.951 41.9041 67.0974 41.85 56.1695C41.7888 42.5031 47.2115 29.3897 56.897 19.7735C62.8657 13.8314 68.8906 7.86165 74.6057 2.17281C75.7879 0.990636 77.6806 1.01058 78.8487 2.17861L111.202 34.7649C112.376 35.939 112.369 37.8449 111.188 38.9996C104.522 45.6388 97.8417 52.2638 91.1684 58.9085C85.7727 64.2634 80.3642 69.6188 74.9695 74.9727L74.6956 75.2467C71.9496 77.964 69.2037 80.6955 66.4577 83.4153L66.3424 83.5305C66.3618 83.5377 66.3688 83.5448 66.3903 83.5519C85.1098 93.1885 103.832 102.798 122.545 112.428C124.014 113.187 124.602 114.99 123.85 116.465L102.862 157.316C102.096 158.79 100.293 159.378 98.8184 158.599L98.8187 158.599Z",
    fill: "url(#paint0_linear_1321_464)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.3916 83.5508L60.1 89.8424C48.7151 101.227 47.3284 118.021 54.4316 130.768C54.9027 131.335 55.4213 131.935 55.9805 132.564C56.0621 132.646 56.1394 132.735 56.2211 132.816C57.7847 134.529 59.6963 136.403 61.971 138.266C64.2672 140.152 67.5111 142.508 71.7583 144.708L98.8195 158.6C100.293 159.378 102.098 158.79 102.863 157.315L123.852 116.465C124.457 115.274 124.192 113.871 123.295 112.975C123.08 112.76 122.831 112.575 122.547 112.428C103.833 102.797 85.1107 93.1898 66.3916 83.5508Z",
    fill: "url(#paint1_linear_1321_464)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1321_464",
    x1: 38.3336,
    y1: 38.3365,
    x2: 130.188,
    y2: 130.191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59C7C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4FA9A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1321_464",
    x1: 58.3825,
    y1: 91.5599,
    x2: 113.601,
    y2: 146.779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41908D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4FA9A7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSectionBg8);
export default __webpack_public_path__ + "static/media/section-bg-8.53756211bec50077b6e759a43edfcae3.svg";
export { ForwardRef as ReactComponent };